import { useNavigate, Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { PageHero, Section, Container, Btn } from "@/components/kit";
import { Eyebrow } from "@/lib/anim";
import { useAuth } from "@/lib/auth";

export default function Account() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const label = "t-caption font-mono uppercase tracking-wide text-[var(--muted)]";

  const signOut = async () => { nav("/", { replace: true }); await logout(); };

  return (
    <>
      <Seo title="Your account" canonical="/account" description="Your Prox account." />
      <PageHero eyebrow="Account" crumbs={[{ label: "Home", to: "/" }, { label: "Account" }]} title={`Welcome, ${user?.name || "there"}.`} lead="Your Prox account." />
      <Section bg="bone">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-7">
            <div className="card p-8" data-testid="account-details">
              <Eyebrow>Your details</Eyebrow>
              <div className="mt-5 space-y-5">
                <div><p className={label}>Name</p><p className="t-body mt-1">{user?.name}</p></div>
                <div><p className={label}>Email</p><p className="t-body mt-1">{user?.email}</p></div>
                <div><p className={label}>Account type</p><p className="t-body mt-1 capitalize">{user?.role}</p></div>
              </div>
              <div className="mt-8 flex flex-wrap gap-4">
                {user?.role === "admin" && <Btn to="/admin" variant="clay" data-testid="account-admin-link">Open admin dashboard</Btn>}
                <Btn onClick={signOut} variant="outline" data-testid="account-logout">Log out</Btn>
              </div>
            </div>
          </div>
          <div className="lg:col-span-5 lg:border-l lg:border-[var(--stone)] lg:pl-10">
            <Eyebrow>Next steps</Eyebrow>
            <div className="space-y-4 t-body mt-4">
              <p className="text-[var(--muted)]">Ready to talk product, cost or sourcing?</p>
              <Btn to="/book" variant="outline">Book a free fit call</Btn>
              <p className="text-[var(--muted)] pt-2">Or explore the <Link to="/services" className="lnk">services</Link> and <Link to="/pricing" className="lnk">pricing</Link>.</p>
            </div>
          </div>
        </div>
      </Section>
    </>
  );
}
